import React from 'react';

import type { HubSectionId } from './hubSectionOrdering';
import { buildOfferTransactionCardModel, type OfferCardModel } from './offerCardModel';
import { TransactionCard } from './TransactionCard';

interface OfferCardProps {
  section: HubSectionId;
  offer: OfferCardModel;
}

export const OfferCard: React.FC<OfferCardProps> = ({ section, offer }) => (
  <TransactionCard section={section} transaction={buildOfferTransactionCardModel(offer)} />
);
